import React from "react";
import { Icon, Flex, Text, BoxProps } from "@chakra-ui/react";
import {
  CheckCircle,
  XCircle,
  PauseCircle,
  PieChart,
  AlertCircle,
} from "react-feather";
import { useTranslation } from "next-i18next";
import { AccreditationTypes } from "@/types/accreditation";
import { getAccreditationStatusColor } from "@/utils/accreditation";

type Props = {
  status: AccreditationTypes;
};

const AccreditationStatus = ({
  status,
  ...props
}: Props & BoxProps): React.ReactElement => {
  const { t } = useTranslation("common");
  let icon = null;

  if (status === AccreditationTypes.PENDING) icon = PauseCircle;
  if (status === AccreditationTypes.GRANTED) icon = CheckCircle;
  if (status === AccreditationTypes.INCOMPLETE) icon = PieChart;
  if (status === AccreditationTypes.CANCELED) icon = AlertCircle;
  if (status === AccreditationTypes.REJECTED) icon = XCircle;

  return (
    <Flex
      bgColor={getAccreditationStatusColor(status)}
      color="white"
      align="center"
      justifyContent={"center"}
      rounded={"xl"}
      height={50}
      width="100%"
      p={{ base: 0, md: 4 }}
      position={{ base: "unset", md: "sticky" }}
      top={1}
      pt={{ base: 0, md: "1.25rem" }}
      mt={{ base: 0, md: "-1.25rem" }}
      zIndex={100}
      {...props}
    >
      <Icon as={icon} w={8} h={8} mr={3} />
      <Text fontSize={"2xl"} fontWeight="bold" letterSpacing={1}>
        {t(`events.statusInfo.${status}`)}
      </Text>
    </Flex>
  );
};

export default AccreditationStatus;
